export default __webpack_public_path__ + "static/media/undraw_package_arrived_63rf.026e4257.svg";